export const updateNewsWithInterestGroup = data => {
	const { allNewsItem, allInterestGroup } = data
	const newsItems = allNewsItem.nodes
	const allInterests = allInterestGroup.nodes

	const advocacyGroupId = "71af4773-8fbb-ec11-983f-00224891cbc8"

	const interestGroupMap = Object.fromEntries(
		allInterests.map(group => [group.interestGroupId, group.name])
	)

	const rtdGroupIds = allInterests
		.filter(group => group.isRTDFilter)
		.map(group => group.interestGroupId)

	return newsItems.map(news => {
		const groupIds = news.interestGroups.map(g => g.interestGroupId)
		const categories = new Set(["All News"])

		const hasAdvocacy = groupIds.includes(advocacyGroupId)

		if (hasAdvocacy) {
			categories.add("Advocacy News")
		}

		const rtdGroupNames = groupIds
			.filter(id => rtdGroupIds.includes(id))
			.map(id => interestGroupMap[id])

		// Add RTD category only if not in Advocacy group
		if (!hasAdvocacy && rtdGroupNames.length > 0) {
			categories.add("Roads & Transport Directorate")
		}

		return {
			...news,
			newsWithInterestGp: [...categories],
			rtdGroupNames,
		}
	})
}
